import { render } from "./MainDeliveryApp.vue?vue&type=template&id=69950788&scoped=true"
import script from "./MainDeliveryApp.vue?vue&type=script&lang=js"
export * from "./MainDeliveryApp.vue?vue&type=script&lang=js"

import "./MainDeliveryApp.vue?vue&type=style&index=0&id=69950788&scoped=true&lang=css"

import exportComponent from "D:\\Sistema\\Nueva carpeta\\erp-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69950788"]])

export default __exports__